import React from 'react';
import styles from './styles.module.scss';
import cc from 'classcat';

interface Props {
  activities: Maybe<ActivitiesFragment>[] | null | undefined;
}

const RetirementVillageActivities = ({ activities }: Props) => {
  if (!activities || activities.length === 0) {
    return null;
  }

  return (
    <div className={cc(['saSection', styles.activitiesBlock])}>
      <div className="saContainer">
        <div className={styles.cardIntro}>
          <p className={styles.preheading}>
            Lifestyle & Services
          </p>

          <h2>
            A range of activities and services
          </h2>

          <p className={styles.subheading}>
            Each Village offers a unique range of activities and services for you to enjoy.
          </p>
        </div>

        <div className={styles.activitiesGrid}>
          {activities.map((activity) => {
            if (!activity) return null;

            const title = activity?.title;
            const iconUrl = activity?.icon?.[0]?.url;

            return (
              <div key={activity.uid || title} className={styles.activityItem}>
                {iconUrl && (
                  <div className={styles.activityIcon}>
                    <img src={iconUrl} alt={title || ''} />
                  </div>
                )}
                {title && (
                  <h3 className={styles.activityTitle}>{title}</h3>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RetirementVillageActivities;

